export const FETCH_DOCUMENT = 'archived/FETCH_DOCUMENT';
export const FETCH_DOCUMENT_ERROR = 'archived/FETCH_DOCUMENT_ERROR';
export const FETCH_DOCUMENT_SUCCESS = 'archived/FETCH_DOCUMENT_SUCCESS';
export const SET_HAS_ARCHIVED = 'archived/SET_HAS_ARCHIVED';
export const SET_SHOULD_REDIRECT = 'archived/SET_SHOULD_REDIRECT';

export const WATCH_FETCH_DOCUMENT = 'archived/WATCH_FETCH_DOCUMENT';
